/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Divider, Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useConfiguration } from '../../redux/features/configuration/useConfiguration';
import { ConfigResourceProps } from '../../redux/enums/ConfigResourceProps';
import { shortFormatDate } from '../../shared/utils/dateUtils';

const useStyles = makeStyles(theme => ({
  label: {
    fontSize: '1rem',
    color: theme.palette.inverted.disabledText,
  },
  value: {
    fontSize: '1rem',
    color: theme.palette.mainText,
    margin: 0,
    padding: 0,
  },
  applicationInfoGrid: {
    marginTop: '1rem',
    marginBottom: '1.1rem',
  },
}));

const visibleFieldsOnly = field => field.uiFormat !== 'hidden';

export default function AutofillFields({ autofillFields }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const autofillRows = autofillFields?.filter(visibleFieldsOnly).reduce(function(rows, key, index) {
    return (index % 2 === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows;
  }, []);
  const frontendCustomisation = useConfiguration(ConfigResourceProps.FRONTEND_CUSTOMISATION);
  const frontendCustomisationDateFormat = frontendCustomisation.resource?.dateFormat;
  const frontendCustomisationBaseDateFinderRegex =
    frontendCustomisation.resource?.baseDateRegex || '\\d{4}-\\d{2}-\\d{2}';

  const renderFormat = (item) => {
    return item.value.match(new RegExp(frontendCustomisationBaseDateFinderRegex))
      ? shortFormatDate(new Date(item.value), frontendCustomisationDateFormat)
      : item.value;
  };

  return (
    <>
      {autofillRows?.length &&
        autofillRows.map((row) => {
          return (
            <Grid id="imported-fields" container spacing={2} columns={12} className={classes.applicationInfoGrid}>
              {row.map((item) => {
                if (item.import === 'yes') {
                  return (
                    <Grid item xs={6}>
                      <span className={classes.label}>{t(item.label)}</span>
                      <p className={classes.value}>{renderFormat(item)}</p>
                    </Grid>
                  );
                }
                return null;
              })}
            </Grid>
          );
        })}

      <Divider />

      {autofillRows?.length &&
        autofillRows.map((row) => {
          return (
            <Grid id="not-imported-fields" container spacing={2} columns={12} className={classes.applicationInfoGrid}>
              {row.map((item) => {
                if (item.import === 'no') {
                  return (
                    <Grid item xs={6}>
                      <span className={classes.label}>{t(item.label)}</span>
                      <p className={classes.value}>{renderFormat(item)}</p>
                    </Grid>
                  );
                }
                return null;
              })}
            </Grid>
          );
        })}
    </>
  );
}
